// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"index-module--contentContainer--2JoZI","articleTitle":"index-module--articleTitle--mijCL","generalArticle":"index-module--generalArticle--36e9u"};